export default "__VITE_ASSET__DBG5__Yq__"